import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { atom, useRecoilState } from "recoil";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import {
  PointTabBar,
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../components/pages/Benefit/Point/PointTab";

import YoutubeMatchingInfo from "./YoutubeMatchingInfo";
import GPTSoloMatchingInfo from "./GPTSoloMatchingInfo";
import { useApi } from "../../hooks/useApi";
import Flex from "../../components/DefaultStyles/Flex";
import { Link } from "react-router-dom";

interface IDefItem {
  id: number;
  name: string;
  cnt: string;
  today: string;
}

const youtubeInfoTabState = atom<number>({
  key: "youtubeInfoTabState",
  default: 0,
});

const REFRESH_INTERVAL = 5000;

export default function YoutubeInfo() {
  const [tab, setTab] = useRecoilState(youtubeInfoTabState);

  const {
    response: defResponse,
    loading: defLoading,
    fetchData: fetchDefData,
  } = useApi({
    method: "get",
    url: "version/systemdef",
  });

  const fetchDefDataRef = useRef(fetchDefData);
  fetchDefDataRef.current = fetchDefData;

  useEffect(() => {
    const id = setInterval(() => {
      fetchDefDataRef.current({
        method: "get",
        url: "version/systemdef",
      });
    }, REFRESH_INTERVAL);

    return () => clearInterval(id);
  }, []);

  const defData: IDefItem[] | undefined = defResponse?.data;

  return (
    <>
      <PageTitle title="개인 연간 판매 파티 관리" />

      <Flex gapSize={8} style={{ marginBottom: "16px", alignItems: "center" }}>
        <StatusCardTitle style={{ marginBottom: "0px" }}>
          오늘 현황
        </StatusCardTitle>
        <Link to={"/linkid-manage/status"}>{'설정으로 이동 > '}</Link>
      </Flex>
      {defData && defData.length > 0 && (
        <StatusBoard>
          {defData.map((d) => (
            <StatusCard key={d.id}>
              <StatusCardTitle>
                {d.name === "youtube_limit" ? "유튜브" : "GPT"}
              </StatusCardTitle>
              <StatusRow>
                <StatusItem>
                  <StatusLabel>오늘</StatusLabel>
                  <StatusValue>{d.today}</StatusValue>
                </StatusItem>
                <StatusItem>
                  <StatusLabel>일일 제한</StatusLabel>
                  <StatusValue>{d.cnt}</StatusValue>
                </StatusItem>
              </StatusRow>
            </StatusCard>
          ))}
        </StatusBoard>
      )}

      <RefreshInfo>5초마다 자동 갱신됩니다</RefreshInfo>

      <PointTabContainer>
        <PointTabColumn onClick={() => setTab(0)}>
          <PointTabText isActive={tab === 0}>유튜브 개인</PointTabText>
          <YoutubeTabBar tab={tab} />
        </PointTabColumn>

        <PointTabColumn onClick={() => setTab(1)}>
          <PointTabText isActive={tab === 1}>GPT 개인</PointTabText>
        </PointTabColumn>
      </PointTabContainer>

      {tab === 0 && <YoutubeMatchingInfo />}
      {tab === 1 && <GPTSoloMatchingInfo />}
    </>
  );
}

const YoutubeTabBar = styled(PointTabBar)`
  width: ${({ tab }) => (tab === 0 ? 80 : 80)}px;
  left: ${({ tab }) => (tab === 0 ? 0 : 100)}px;
`;

const StatusBoard = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const StatusCard = styled.div`
  flex: 1;
  min-width: 200px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
`;

const StatusCardTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #2f2f38;
  margin-bottom: 12px;
`;

const StatusRow = styled.div`
  display: flex;
  gap: 24px;
`;

const StatusItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

const StatusLabel = styled.span`
  font-size: 13px;
  color: #808080;
`;

const StatusValue = styled.span`
  font-size: 22px;
  font-weight: 700;
  color: #1565c0;
`;

const RefreshInfo = styled.div`
  font-size: 12px;
  color: #9e9e9e;
  text-align: right;
  margin-bottom: 12px;
`;
